export const employeePositionColors = {
  STANDARD: "white",
  CS: "blue",
  OD: "cyan",
  SM: "purple",
  ASM: "magenta",
};
